import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LoginResponse, OidcSecurityService } from 'angular-auth-oidc-client';
import { firstValueFrom, map } from 'rxjs';

/** Where the guard stashes a deep link that was blocked by authentication. */
export const RETURN_URL_KEY = 'auth.returnUrl';

export const authGuard: CanActivateFn = (route, state) => {
  const oidcSecurityService = inject(OidcSecurityService);
  const router = inject(Router);

  return firstValueFrom(
    oidcSecurityService.checkAuth().pipe(
      map((loginResponse: LoginResponse) => {
        const { isAuthenticated } = loginResponse;
        if (!isAuthenticated) {
          // Remember where the user was headed so the post-login navigation can restore it.
          sessionStorage.setItem(RETURN_URL_KEY, state.url);
          return router.createUrlTree(['/not-authorized']);
        }

        const returnUrl = sessionStorage.getItem(RETURN_URL_KEY);
        sessionStorage.removeItem(RETURN_URL_KEY);
        if (returnUrl && returnUrl !== state.url) {
          return router.parseUrl(returnUrl);
        }
        return true;
      })
    )
  );
};
